module.exports = __webpack_public_path__ + "8c823202dae960d363a9b2cfcf4a1eb2.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1151
// module chunks = 0